import { useAiOnboardingSessionStorage } from 'domain/onboarding/company/Wizard/AIOnboarding';
import React, { useState } from 'react';
import { ExecutiveSummaryDTO, ICompany } from 'types/company';
import SectionHeading from 'ui/elements/SectionHeading';
import EditAction from 'ui/elements/actions/EditAction';
import CtaButton from 'ui/elements/buttons/CtaButton';
import Card from 'ui/views/cards/Card';
import AIChip from '../AiChip';
import WhyInvestDialog from './WhyInvestDialog';

interface Props {
  company: ICompany;
  executiveSummary: ExecutiveSummaryDTO;
  canEditCompany: boolean;
  onSave?: () => void;
}

export default function WhyInvestSection({ company, executiveSummary, canEditCompany, onSave }: Props) {
  const [isWhyInvestDialogOpen, setIsWhyInvestDialogOpen] = useState(false);
  const [isAiOnboarding] = useAiOnboardingSessionStorage();

  return (
    <>
      {(canEditCompany || executiveSummary.unfairAdvantage) && (
        <div>
          <SectionHeading
            heading={
              <>
                Why invest in us?
                {isAiOnboarding && executiveSummary.unfairAdvantage && (
                  <AIChip className="u-half-spacing-left" onClick={() => setIsWhyInvestDialogOpen(true)} />
                )}
              </>
            }
            addMobileMargin
          >
            {canEditCompany && (
              <button onClick={() => setIsWhyInvestDialogOpen(true)} aria-label="Edit section">
                <EditAction tooltip="Edit section" />
              </button>
            )}
          </SectionHeading>
          <Card>
            {!executiveSummary.unfairAdvantage && canEditCompany ? (
              <CtaButton className="u-half-spacing-y" height={100} onClick={() => setIsWhyInvestDialogOpen(true)}>
                Which competitive advantages do you have that will help you succeed with your vision?
              </CtaButton>
            ) : (
              <p className="u-half-spacing-y text-body">{executiveSummary.unfairAdvantage}</p>
            )}
          </Card>
        </div>
      )}

      <WhyInvestDialog
        company={company}
        executiveSummary={executiveSummary}
        isOpen={isWhyInvestDialogOpen}
        onClose={() => setIsWhyInvestDialogOpen(false)}
        onSuccess={onSave}
      />
    </>
  );
}
